module.exports = __webpack_public_path__ + "static/img/step1-active.00d6fbe3.png";